/* eslint-disable no-prototype-builtins */
/* eslint-disable max-len */
/* eslint-disable no-new */
import EDC from '../globals';
import BackgroundPreloader from '../preloader-background';
import MusicPreloader from '../preloader-music';
import { SummaryPreloader } from '../summary';
import { ThumbsPreloader } from '../thumbs-animation';
import { MenuPreloader } from '../menu';
import { AnswerMarkPreloader } from '../mark-animation';
import { QuestionPreloader } from '../question';

// import { QuickPanelPreloader } from "../quick-panel";

/**
 *
 */
EDC.Games.BaseMinigamesPreloader = function () {};
/**
 *
 */
EDC.Games.BaseMinigamesPreloader.prototype.addPreloaders = function (gameConfig, loadersConfig) {
  const needBackground = this.getPropertyValue(loadersConfig, 'background');
  const needMusic = this.getPropertyValue(loadersConfig, 'background');
  const needSummary = this.getPropertyValue(loadersConfig, 'summary');
  const needThumbs = this.getPropertyValue(loadersConfig, 'thumbs');
  const needMenu = this.getPropertyValue(loadersConfig, 'menu');
  const needAnswerMark = this.getPropertyValue(loadersConfig, 'answer-mark');
  const needQuestion = this.getPropertyValue(loadersConfig, 'question');
  // const needQuickPanel = this.getPropertyValue(loadersConfig, "quick-panel");

  if (needBackground) new BackgroundPreloader(this, gameConfig.bgList);
  if (needMusic) new MusicPreloader(this, gameConfig.musicList);
  if (needSummary) new SummaryPreloader(this, true);
  if (needThumbs) new ThumbsPreloader(this);
  if (needMenu) new MenuPreloader(this);
  if (needAnswerMark) new AnswerMarkPreloader(this);
  if (needQuestion) new QuestionPreloader(this);

  // this.load.setPath('https://s3.amazonaws.com/images.growmindgrow/phaser-assets/images/AboutButton');
  // this.about = new AboutPreloader(this).preload();
  // if (needQuickPanel) new QuickPanelPreloader(this);
};
/**
 *
 */
EDC.Games.BaseMinigamesPreloader.prototype.getPropertyValue = function (loadersConfig, propertyName) {
  return loadersConfig.hasOwnProperty(propertyName) ? loadersConfig[propertyName] : true;
};

export default EDC.Games.BaseMinigamesPreloader;
